import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Agencia } from 'src/app/entidades/agencia';
import { Campanha } from 'src/app/entidades/campanha';
import { Cliente } from 'src/app/entidades/cliente';
import { ContaBancaria } from 'src/app/entidades/contaBancaria';
import { Cupom } from 'src/app/entidades/cupom';
import { DadosAdesao } from 'src/app/entidades/dadosAdesao';
import { DefinicaoColuna } from 'src/app/entidades/definicaoColuna';
import { Log } from 'src/app/entidades/log';
import { Produto } from 'src/app/entidades/produto';
import { Usuario } from 'src/app/entidades/usuario';
import { FiltroCliente } from 'src/app/enum/filtroCliente';
import { enumToArray } from 'src/app/helper/enumToArray';
import { CpfPipe } from 'src/app/pipes/cpf/cpf.pipe';
import { RealPipe } from 'src/app/pipes/real/real.pipe';
import { AgenciaService } from 'src/app/services/agencia/agencia.service';
import { ApiService } from 'src/app/services/api/api.service';
import { CampanhaService } from 'src/app/services/campanha/campanha.service';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { CupomService } from 'src/app/services/cupom/cupom.service';
import { LogService } from 'src/app/services/log/log.service';
import { MensagemService } from 'src/app/services/mensagem/mensagem.service';
import { PesquisaService } from 'src/app/services/pesquisa/pesquisa.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { cpfCnpjValidator } from 'src/app/validadores/cpfCnpjValidador';
import { Validador } from 'src/app/validadores/validador';
import { DialogoComponent } from '../dialogo/dialogo/dialogo.component';
import { CupomAgrupadoDto } from './../../dto/cupomAgrupadoDto';
import { TipoPagamentoCupom } from './../../enum/tipoPagamentoCupom';

@Component({
  selector: 'app-termo-adesao',
  templateUrl: './termo-adesao.component.html',
  styleUrls: ['../../app.component.css', './termo-adesao.component.css'],
})
export class TermoAdesaoComponent implements OnInit, OnDestroy {
  private textoCooperadoNome = new Subject<string>();
  step = 0;
  clientes: Cliente[];
  mascaraCNPJCPF: string;
  produtos: Produto[];
  usuarios: Usuario[];
  agencias: Agencia[];
  contasDoCooperado: ContaBancaria[];
  dadosAdesao: DadosAdesao;
  tiposPagamento = enumToArray(TipoPagamentoCupom);
  titulo: string;
  cupomAtual: Cupom;
  campanha: Campanha;
  formulario: FormGroup;
  pagamentoParcelado: boolean;
  pagamentoParceladoEntrada: boolean;
  cupomAgrupadoDto: CupomAgrupadoDto;
  gerarTermoCampanha: boolean;
  campanhasVigentes: boolean;
  semPermissao: boolean = false;
  idTermoAdesao: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private cupomService: CupomService,
    private mensagemService: MensagemService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private apiService: ApiService,
    private campanhaService: CampanhaService,
    private activatedRoute: ActivatedRoute,
    private usuarioService: UsuarioService,
    private pesquisaService: PesquisaService,
    private agenciaService: AgenciaService,
    private datePipe: DatePipe,
    private realPipe: RealPipe,
    private dialog: MatDialog,
    private clienteService: ClienteService,
    private logService: LogService
  ) {}

  ngOnDestroy(): void {}

  async ngOnInit(): Promise<void> {
    this.mascaraCNPJCPF = '000.000.000-00||AA.AAA.AAA/AAAA-00';
    this.formulario = this.formBuilder.group({
      nomeCliente: [null, Validators.required],
      cpfCNPJ: [null, [Validators.required, cpfCnpjValidator()]],
      email: [null, [Validators.required, Validators.email, Validador.isEmailCorporativo]],
      telefone: [null, Validators.required],
      agencia: [null, Validators.required],
      produtoId: [null, Validators.required],
      colaborador: [this.apiService.UsuarioLogado, Validators.required],
      conta: [null, Validators.required],
      qtdeCupons: [1, Validators.required],
      valorPago: [null, Validators.required],
      tipoPagamento: [null, Validators.required],
      parcelas: [0],
      valorParcela: [0],
      dataDebito: [null],
      valorEntrada: [0],
    });
    this.carregarListas();
    this.pesquisaService.resultadoEmitter.subscribe((res: Cliente) => {
      this.adicionarCooperado(res);
    });
    const path = this.activatedRoute.snapshot.url.map((u) => u.path)[0];
    if (path !== 'Cupom')
      this.campanhasVigentes =
        this.activatedRoute.snapshot.url.map((u) => u.path)[3].toString() ===
        'false'
          ? false
          : true;
    this.gerarTermoCampanha = path === 'Campanha';
    if (!this.gerarTermoCampanha) {
      this.idTermoAdesao = Number(this.activeRoute.snapshot.paramMap.get('id'));
      await this.cupomService.ObterCupom(this.idTermoAdesao).then(async (result) => {
        this.cupomAtual = result as Cupom;
        await this.cupomService.obterCupomAgrupado(this.idTermoAdesao).then((ca) => {
          this.cupomAgrupadoDto = ca as CupomAgrupadoDto;
        });
        await this.obterCampanha(this.cupomAtual?.idCampanha);
        /* Verifica se já possui termo gerado */
        await this.campanhaService
          .obterTermoAdesao(this.cupomAtual?.agrupamento)
          .then((res) => {
            this.dadosAdesao = res as DadosAdesao;
            this.idTermoAdesao = this.dadosAdesao.id;
            this.verificarPermissao();
          });
        this.popularForm();
      });
    } else {
      let idCampanha = Number(
        this.activatedRoute.snapshot.url.map((u) => u.path)[2]
      );
      await this.obterCampanha(idCampanha);
    }
    this.titulo =
      this.dadosAdesao !== null && this.dadosAdesao !== undefined
        ? 'Alterar Termo de Adesão'
        : 'Gerar Termo de Adesão';
    this.titulo += ` - CAMPANHA: ${this.campanha.nome}`;
    this.formulario.get('valorPago').setValue(this.getValor());
  }

  getValor(): number {
    let quantidade = Number(this.formulario.get('qtdeCupons').value);
    return this.campanha.valorCupom * quantidade;
  }

  atualizaValor(): void {
    this.formulario.get('valorPago').setValue(this.getValor());
    this.verificarParcela();
  }

  async obterCampanha(id: number): Promise<void> {
    await this.campanhaService.ObterCampanha(id).then((res) => {
      this.campanha = res as Campanha;
    });
  }

  popularForm(): void {
    this.mascaraCNPJCPF = null;
    this.formulario.patchValue({
      nomeCliente: this.cupomAtual.nome,
      cpfCNPJ: this.cupomAtual.cpF_CNPJ,
      conta: this.cupomAtual.conta,
      email: this.cupomAtual.email,
      telefone: this.cupomAtual.telefone,
      agencia: this.cupomAtual.agencia,
      produtoId: this.cupomAtual.produtoId,
      colaborador: this.usuarios.filter(
        (x) => x.id === this.cupomAtual.idColaborador
      )[0],
      qtdeCupons:
        this.dadosAdesao !== null && this.dadosAdesao !== undefined
          ? this.dadosAdesao.qtdeCupons
          : 1 /*this.cupomAgrupadoDto !== null && this.cupomAgrupadoDto !== undefined ? this.cupomAgrupadoDto.quantidadeCupons : this.cupomAtual.quantidade,*/,
      valorPago:
        /*this.cupomAgrupadoDto !== null && this.cupomAgrupadoDto !== undefined ? this.cupomAgrupadoDto.valorCupons :*/ this
          .cupomAtual?.quantidade * this.campanha?.valorCupom,
      tipoPagamento:
        this.dadosAdesao !== null && this.dadosAdesao !== undefined
          ? this.dadosAdesao.tipoPagamento
          : null,
      parcelas:
        this.dadosAdesao !== null && this.dadosAdesao !== undefined
          ? this.dadosAdesao.parcelas
          : 0,
      valorParcela:
        this.dadosAdesao !== null && this.dadosAdesao !== undefined
          ? this.dadosAdesao.valorParcela
          : 0,
      dataDebito:
        this.dadosAdesao !== null && this.dadosAdesao !== undefined
          ? this.dadosAdesao.dataDebito
          : null,
      valorEntrada:
        this.dadosAdesao != null && this.dadosAdesao !== undefined
          ? this.dadosAdesao.valorEntrada
          : 0,
    });
    this.mascaraCNPJCPF =
      this.cupomAtual.cpF_CNPJ.length === 11
        ? '000.000.000-00'
        : '00.000.000/0000-00';
    this.formulario.markAsPristine();
  }

  cancelar(): void {
    if (!this.gerarTermoCampanha)
      this.router.navigate([`/Cupom/${this.cupomAtual.idCampanha}`]);

    if (
      this.campanhasVigentes ||
      (this.apiService.UsuarioLogado.nivel !== 'ADMINISTRADOR' &&
        this.apiService.UsuarioLogado.nivel !== 'ASSESSOR')
    )
      this.router.navigate(['/campanhas/vigentes']);
    else this.router.navigate(['/Campanhas']);
  }

  async onSubmit(): Promise<void> {
    try {
      /* Verifica se os cupons foram quitados */
      let cuponsQuitados = false;
      if (this.cupomAtual != null && this.cupomAtual !== undefined && this.idTermoAdesao > 0) {
        cuponsQuitados = await this.campanhaService.verificarCuponsQuitados(
          this.cupomAtual.agrupamento
        );
        const dialogRef = this.dialog.open(DialogoComponent, {
          data: {
            titulo: 'Cuidado!',
            pergunta: cuponsQuitados
              ? `Todos os cupons referente ao Termo de Adesão já foram quitados e gerados. A alteração poderá causar inconsistência nos dados, perda dos números gerados e parcelamento já realizado. Altere por sua conta e risco! Confirma a alteração?`
              : 'Cupons e parcelamentos pertencentes ao Termo de Adesão que já tenham sido gerados serão perdidos. Confirma a alteração?',
          },
          width: '550px',
        });
        dialogRef.afterClosed().subscribe(async (result) => {
          if (result === 'yes') {
            this.adicionaTermo(cuponsQuitados);
          }
        });
      } else {
        this.adicionaTermo(cuponsQuitados);
      }
    } catch (error) {
      console.log(error);
      this.mensagemService.showMessage(
        `Erro ao gerar Termo de Adesão.`,
        'Ok',
        5000,
        'error'
      );
    }
  }

  async adicionaTermo(cuponsQuitados: boolean) {
    /* Preenche o novo cupom  */
    this.cupomAtual = {
      id: this.cupomAtual?.id > 0 ? this.cupomAtual?.id : 0,
      agrupamento: this.cupomAtual?.agrupamento,
      nome: this.formulario.get('nomeCliente').value,
      cpF_CNPJ: this.formulario.get('cpfCNPJ').value,
      email: this.formulario.get('email').value,
      telefone: this.formulario.get('telefone').value,
      agencia: this.formulario.get('agencia').value,
      conta: this.formulario.get('conta').value,
      ehCooperado: false,
      dataEmissao: new Date(),
      idColaborador: (this.formulario.get('colaborador').value as Usuario).id,
      idCampanha: this.campanha.id,
      produtoId: this.formulario.get('produtoId').value,
      quantidade: this.formulario.get('qtdeCupons').value,
      foiParcelado:
        this.formulario.get('tipoPagamento').value ===
        TipoPagamentoCupom.À_Vista
          ? false
          : true,
      foiQuitado:
        this.formulario.get('tipoPagamento').value ===
        TipoPagamentoCupom.À_Vista
          ? true
          : false,
      paColaborador: (this.formulario.get('colaborador').value as Usuario)
        .codPA,
    } as Cupom;
    this.dadosAdesao = {
      id: this.idTermoAdesao > 0 ? this.idTermoAdesao : 0,
      idCampanha: this.cupomAtual.idCampanha,
      idColaborador: (this.formulario.get('colaborador').value as Usuario).id,
      nomeCliente: this.formulario.get('nomeCliente').value,
      cpfCNPJ: this.formulario.get('cpfCNPJ').value,
      conta: this.formulario.get('conta').value,
      qtdeCupons: this.formulario.get('qtdeCupons').value,
      agrupamento:
        this.cupomAtual.agrupamento !== null &&
        this.cupomAtual.agrupamento !== undefined
          ? this.cupomAtual.agrupamento
          : '',
      valorPago: this.formulario.get('valorPago').value,
      tipoPagamento: this.formulario.get('tipoPagamento').value,
      valorEntrada:
        this.formulario.get('tipoPagamento').value ===
        TipoPagamentoCupom.Parcalado_com_entrada
          ? Number(
              this.formulario
                .get('valorEntrada')
                .value?.toString()
                .replace(',', '.')
            )
          : 0,
      parcelas: this.formulario.get('parcelas').value,
      valorParcela:
        this.formulario.get('valorParcela').value !== null
          ? Number(
              this.formulario
                .get('valorParcela')
                .value?.toString()
                .replace(',', '.')
            )
          : 0,
      dataDebito: this.formulario.get('dataDebito').value,
      cupom: this.cupomAtual,
    } as DadosAdesao;
    await this.cupomService
      .adicionarTermoAdesao(this.dadosAdesao)
      .then((res) => {
        this.dadosAdesao = res as DadosAdesao;
        this.verificarPermissao();
      });
    if (cuponsQuitados) {
      var log = {
        usuarioId: this.apiService.UsuarioLogado.id,
        descricao: `[ALTEROU TERMO DE ADESÃO] Após aviso sobre perda de parcelamento e inconsistência de dados, o usuário optou por alterar o Termo de Adesão ${this.dadosAdesao.id} em nome de ${this.dadosAdesao.nomeCliente}`,
      } as Log;
      await this.logService.adicionar(log);
    }
    await this.imprimirTermo();
    this.cancelar();
  }

  limparFormulario(): void {
    this.formulario.patchValue({
      nomeCliente: null,
      cpfCNPJ: null,
      conta: null,
      qtdeCupons: 0,
      valorPago: 0,
      tipoPagamento: 0,
      parcelas: 1,
      valorParcela: 0,
      dataDebito: null,
    });
  }

  tipoPagamentoChange(event: any): void {
    switch (event) {
      case 1:
        this.pagamentoParcelado = false;
        this.pagamentoParceladoEntrada = false;
        this.formulario.get('parcelas').clearValidators();
        this.formulario.get('valorParcela').clearValidators();
        this.formulario.get('dataDebito').clearValidators();
        this.formulario.get('valorEntrada').clearValidators();
        this.formulario.get('parcelas').setValue("0");
        this.formulario.get('valorParcela').setValue("0");
        this.formulario.get('dataDebito').setValue(null);
        this.formulario.get('valorEntrada').setValue("0");
        break;
      case 2:
        this.pagamentoParcelado = true;
        this.pagamentoParceladoEntrada = false;
        this.formulario.get('parcelas').setValidators(Validators.required);
        this.formulario.get('valorParcela').setValidators(Validators.required);
        this.formulario.get('dataDebito').setValidators(Validators.required);
        this.formulario.get('valorEntrada').clearValidators();
        this.verificarParcela();
        break;
      case 3:
        this.pagamentoParcelado = false;
        this.pagamentoParceladoEntrada = true;
        this.formulario.get('parcelas').setValidators(Validators.required);
        this.formulario.get('valorParcela').setValidators(Validators.required);
        this.formulario.get('dataDebito').setValidators(Validators.required);
        this.formulario.get('valorEntrada').setValidators(Validators.required);
        this.verificarParcela();
        break;
      default:
        break;
    }
    this.formulario.get('parcelas').updateValueAndValidity();
    this.formulario.get('valorParcela').updateValueAndValidity();
    this.formulario.get('dataDebito').updateValueAndValidity();
    this.formulario.get('valorEntrada').updateValueAndValidity();
  }

  verificarParcela(): void {
    let valorPago =
      Number(this.formulario.get('valorPago').value) -
      Number(this.formulario.get('valorEntrada').value);
    let parcelas = Number(this.formulario.get('parcelas').value);
    let qtdeMaxParcelas = valorPago / 100;
    let dataAtual = new Date();
    let anoAtual = dataAtual.getFullYear();
    let anoFim = new Date(this.campanha.dataFim).getFullYear();
    let mesFimCampanha = new Date(this.campanha.dataFim).getMonth() + 1;

    if (
      anoAtual == anoFim &&
      this.apiService.UsuarioLogado.nivel !== 'ADMINISTRADOR' &&
      this.apiService.UsuarioLogado.nivel !== 'ASSESSOR'
    ) {
      let mesAtual = dataAtual.getMonth() + 1;
      if (mesAtual === mesFimCampanha) {
        qtdeMaxParcelas = 1;
        this.mensagemService.showMessage(
          'Limite de Parcelamento',
          `Atenção! Data limite para o pagamento é de ${this.datePipe.transform(
            this.campanha.dataFim,
            'dd/MM/yyyy'
          )}.`,
          5000,
          'warning'
        );
        this.formulario.get('parcelas').setValue(qtdeMaxParcelas);
        this.formulario.get('parcelas').updateValueAndValidity();
        return;
      }
      qtdeMaxParcelas = mesAtual === 1 ? 12 : 12 - mesAtual;
      if (parcelas > qtdeMaxParcelas) {
        this.mensagemService.showMessage(
          'Limite de Parcelamento',
          `Parcelamento máximo ${qtdeMaxParcelas}x.`,
          5000,
          'warning'
        );
        this.formulario.get('parcelas').setValue(qtdeMaxParcelas);
        this.formulario.get('parcelas').updateValueAndValidity();
        return;
      }
    }
    if (valorPago === 0) valorPago = 1;
    if (parcelas === 0) {
      parcelas = 1;
    }
    let valorParcela = valorPago / parcelas;
    let valorMinimo = this.campanha.valorCupom / 12;
    if (valorParcela < valorMinimo) {
      this.mensagemService.showMessage(
        `Parcela não pode ser menor que ${this.realPipe.transform(
          valorMinimo
        )}`,
        'Ok',
        5000,
        'warning'
      );
      parcelas = valorPago / valorMinimo;
      valorParcela = valorPago / parcelas;
    }

    this.formulario.get('parcelas').setValue(parcelas);
    this.formulario.get('parcelas').updateValueAndValidity();
    this.formulario.get('valorParcela').setValue(valorParcela);
    this.formulario.get('valorParcela').disable();
    this.formulario.get('valorParcela').updateValueAndValidity();
  }

  async imprimirTermo(): Promise<void> {
    await this.cupomService
      .imprimirTermoAdesao(this.dadosAdesao)
      .then(async (result) => {
        if (result !== null && result !== undefined) {
          let file = new File([result], 'Termo de Adesão.pdf', {
            type: (<any>result).type,
          });
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.apiService.StrDocument = reader.result as string;
            this.apiService.pdfViewerEmitter.emit(true);
          };
        } else {
          this.mensagemService.showMessage(
            'Erro ao gerar Termo de Adesão.',
            'Ok',
            5000,
            'error'
          );
        }
      });
  }

  async imprimirCupom(): Promise<void> {
    if (
      this.dadosAdesao.cupom !== null &&
      this.dadosAdesao.cupom !== undefined
    ) {
      if (!this.dadosAdesao.cupom?.foiParcelado) {
        this.aguardaImpressao();
      }
    }
  }

  aguardaImpressao(): void {
    setTimeout(() => {
      if (!this.apiService.PdfViewerIsShowing) {
        this.campanhaService
          .emitirCupom(this.dadosAdesao?.cupom?.id)
          .then((result) => {
            if (result !== null && result !== undefined) {
              this.mensagemService.showMessage(
                'Cupom obtido com sucesso.',
                'Ok',
                5000,
                'success'
              );
              let file = new File([result], 'Cupom.pdf', {
                type: (<any>result).type,
              });
              let reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => {
                this.apiService.StrDocument = reader.result as string;
                this.apiService.pdfViewerEmitter.emit(true);
              };
            } else {
              this.mensagemService.showMessage(
                'Erro ao obter Cupom.',
                'Ok',
                5000,
                'error'
              );
            }
          });
      }
      if (this.apiService.PdfViewerIsShowing) this.aguardaImpressao();
    }, 1000);
  }

  searchCooperado(valorDigitado: string) {
    this.textoCooperadoNome.next(valorDigitado);
  }

  async pesquisaCooperado(): Promise<void> {
    if (this.isReadOnly()) return;
    const definicaoColunas: DefinicaoColuna[] = [
      { definicao: 'id', exibicao: 'Id' },
      { definicao: 'associado', exibicao: 'Nome' },
      { definicao: 'cpF_CNPJ', exibicao: 'CPF / CNPJ' },
      { definicao: 'conta', exibicao: 'Conta' },
    ];
    const colunas = this.clientes?.map((c) => {
      return {
        id: c.id,
        associado: c.associado,
        cpF_CNPJ: c.cpF_CNPJ,
        conta: c.conta,
      };
    });
    this.pesquisaService.pesquisaEventEmitter.emit(true);
    this.pesquisaService.tituloEventEmitter.emit('Adicionar Cooperado');
    this.pesquisaService.mensagemEventEmitter.emit(
      'Selecione o Cooperado desejado'
    );
    this.pesquisaService.colunasEmitter.emit(colunas);
    this.pesquisaService.functionEmitter.emit(this.clienteService.obter);
    this.pesquisaService.entidadeServiceEmitter.emit(this.clienteService);
    this.pesquisaService.filtrosEmitter.emit(enumToArray(FiltroCliente));
    this.pesquisaService.filtroEmitter.emit(
      this.clienteService.filtroClienteEmitter
    );
    this.pesquisaService.descricaoFEmitter.emit(
      this.clienteService.descricaoFiltroEmitter
    );
    this.pesquisaService.columnsHeadersEmitter.emit(definicaoColunas);
    this.pesquisaService.moduloCotacaoEmitter.emit(true);
  }

  async carregarListas(): Promise<void> {
    this.produtos = [
      {
        id: 1,
        descricao: 'QUOTAS DE CAPITAL',
        grupo: null,
        grupoId: 0,
        exigirAnexoMCI: false,
        geraComissao: false,
        inativo: false,
        ramoAtividadeId: 0,
        ramoAtividade: null,
      },
      //{ id: 2, descricao: "PREVIDÊNCIA", grupo: null, grupoId: 0, exigirAnexoMCI: false, geraComissao: false },
      {
        id: 3,
        descricao: 'PONTOS SICOOB CARD',
        grupo: null,
        grupoId: 0,
        exigirAnexoMCI: false,
        geraComissao: false,
        inativo: false,
        ramoAtividadeId: 0,
        ramoAtividade: null,
      },
    ];
    this.agenciaService.todas().then((result) => {
      this.agencias = this.apiService.verificaSeResult<Agencia[]>(result);
    });

    /* Clientes Obtém o primeiro Cliente para gerar as colunas da consulta */
    await this.clienteService
      .obter(
        {
          length: 0,
          pageIndex: 0,
          pageSize: 1,
          previousPageIndex: 0,
        },
        true
      )
      .then((res) => {
        this.clientes = this.apiService.verificaSeResult<Cliente[]>(res.dados);
      });
    /* Usuários */
    this.usuarioService.ObterColaboradores().then((result) => {
      this.usuarios = result;
      this.formulario.patchValue({
        colaborador: this.apiService.UsuarioLogado,
      });
      this.formulario.markAsPristine();
    });
  }

  adicionarCooperado(cooperado: Cliente): void {
    let contas = cooperado.contas;
    let conta = '';
    let codPA = '';
    if (contas.length > 0) {
      conta = contas !== null ? contas[0].numeroConta : cooperado.conta;
      codPA = contas !== null ? contas[0].codPA : '';
    } else {
      conta = cooperado.conta;
    }
    let inputCooperado = document.getElementById('inputCooperado');
    if (inputCooperado !== null && inputCooperado !== undefined) {
      (<any>inputCooperado).value = cooperado.associado;
    }
    this.formulario.patchValue({
      clienteId: cooperado.id,
    });
    this.mascaraCNPJCPF = null;
    let documento = new CpfPipe().transform(cooperado.cpF_CNPJ);
    this.formulario.get('cpfCNPJ').setValue(documento);
    this.formulario.get('nomeCliente').setValue(cooperado.associado);
    this.formulario.get('telefone').setValue(cooperado.telefoneCelular);
    this.formulario.get('agencia').setValue(codPA);
    this.formulario.get('conta').setValue(conta);
    this.contasDoCooperado = contas?.filter((x) => x.ativa);
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  isReadOnly(): boolean {
    return this.semPermissao;
  }

  verificarPermissao(): void {
    if (this.dadosAdesao === null || this.dadosAdesao === undefined) {
      this.semPermissao = false;
      return;
    }
    this.semPermissao =
      this.apiService.UsuarioLogado.nivel !== 'ADMINISTRADOR' &&
      this.apiService.UsuarioLogado.nivel !== 'ASSESSOR';
  }
}
